import React, { Component } from 'react'
import Main from './containers/Main'
import '../scss/match.scss'
import '../scss/index.scss'

// console.log = () => null

class Index extends Component {
    
    constructor(props)
    {
        super(props)
    }

    render()
    {
        return <>
            <Main />
        </>
    }
}

export default Index